/**
 *
 * FlashCardDetail
 *
 */

export default {
  name: 'FlashCardStartBtn',

  methods: {
    handleClickStartBtn() {
      this.$emit('start-flash-card-list');
    },
  },
};
